<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">KULLANICI TÜRÜNE GÖRE ROUTER YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchRouter = !showSearchRouter">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Kullanıcı Türüne Göre Router Arama</span>
        </h2>

        <div v-if="showSearchRouter" class="card-bg p-5">
          <form @submit.prevent="getRouterDefaultUserType()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Id</b></label>
                <vs-input size="large" type="number" style="width: 100%;" v-model="routerDefaultUserTypeSearch.id" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>User Türü</b></label>
                <v-select @input="getRouterDefaultUserType()" name="label" v-model="routerDefaultUserTypeSearch.userType" placeholder="Seçiniz" :options="userTypeList" label="name" class="w-full" :reduce="(row) => row.name">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Router</b></label>
                <v-select @input="getRouterDefaultUserType()" name="label" v-model="routerDefaultUserTypeSearch.routerId" placeholder="Seçiniz" :options="routerList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddRouter = !showAddRouter">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Kullanıcı Türüne Göre Router Oluştur</span>
        </h2>
        <div v-if="showAddRouter" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>User Türü</b></label>
                <v-select name="label" v-model="routerDefaultUserTypeItem.userType" placeholder="Seçiniz" :options="userTypeList" label="name" class="w-full" :reduce="(row) => row.name">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Router</b></label>
                <v-select name="label" v-model="routerDefaultUserTypeItem.routerId" placeholder="Seçiniz" :options="routerList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveRouterDefaultUserType(routerDefaultUserTypeItem, 'Insert', '')"> Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Kullanıcı Türüne Göre Routerlar</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="routerDefaultUserList">
            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>User Türü</vs-th>
              <vs-th>Router</vs-th>
              <vs-th>Router Açıklama</vs-th>
              <vs-th>İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.id">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.id }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="width: 20%;">
                    <v-select name="label" style="width: 300px;" v-model="tr.userType" placeholder="Seçiniz" :options="userTypeList" label="name" class="w-full" :reduce="(row) => row.name"></v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="width: 30%;">
                    <v-select name="Id" style="width: 300px;" v-model="tr.routerId" :options="routerList" label="name" :reduce="(row) => row.id"> </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 20%;">
                    <b> {{ tr.description }}</b>
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveRouterDefaultUserType(tr, 'Delete', 'Kullanıcı türündeki router izni silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveRouterDefaultUserType(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      routerDefaultUserTypeItem: { id: null, userType: null, routerId: null },
      routerDefaultUserList: [],
      routerList: [],
      userTypeList: [],
      userTypeSearch: { id: null, name: null },
      routerDefaultUserTypeSearch: { id: null, userType: null, routerId: null },
      routerSearch: { id: null, name: null, description: null },
      showAddRouter: false,
      showSearchRouter: false,
    };
  },

  computed: {},
  methods: {
    getUserType: async function () {
      this.$vs.loading();
      this.userTypeList = await repository.postEntity("ParametricScreens/getUserType", this.userTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getRouterDefaultUserType: async function () {
      this.$vs.loading();
      this.routerDefaultUserList = await repository.postEntity("ParametricScreens/getRouterDefaultUserType", this.routerDefaultUserTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getRouter: async function () {
      this.$vs.loading();
      this.routerList = await repository.postEntity("ParametricScreens/GetRouter", this.routerSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveRouterDefaultUserType: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveRouterDefaultUserType", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.routerDefaultUserTypeItem = {};
      this.routerDefaultUserTypeSearch = {};
      this.getRouterDefaultUserType();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getRouter(), this.getRouterDefaultUserType(), this.getUserType()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
